import { links } from 'bzx-common/src/config/appConfig'
import { useElementSizeQuery } from 'ui-framework'
import { observer } from 'mobx-react'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import DashboardVM from '../DashboardVM'

const mediaQueries: { minWidth: [number, string][] } = {
  minWidth: [[420, 'lobby__dao--md']],
}

export function LobbyDao({ vm }: { vm: DashboardVM }) {
  const { stakingStore } = vm.rootStore
  const [media, setRef] = useElementSizeQuery(mediaQueries)

  return (
    <div
      className={`lobby__dao ${media.minWidth} panel--simple pos-rel overflow-hidden`}
      ref={setRef}>
      <div className=" height-100p">
        <div className="lobby__dao-header">
          <div className="lobby__dao-img" />
          <h3 className="lobby__dao-title">DAO</h3>
          <div className="lobby__dao-links">
            <h3 className="txt-black">Get involved</h3>
            <ExternalLink className="btn btn--blue margin-right-1" href={links.forum}>
              Forum
            </ExternalLink>
            <ExternalLink className="btn btn--blue" href={links.daoSnapshot}>
              Proposals
            </ExternalLink>
          </div>
        </div>
        <div className="padded-1 flex-col height-100p">
          <div className="">
            {stakingStore.dao.snapshotProposals.length > 0 && (
              <>
                <h3 className="title-section">Latest proposals</h3>

                <ul className="margin-0 list-spaced-2">
                  {stakingStore.dao.snapshotProposals.slice(0, 5).map((proposal) => {
                    return (
                      <li key={proposal.id}>
                        <div className="truncate width-100p">{proposal.title}</div>
                      </li>
                    )
                  })}
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default observer(LobbyDao)
